import React, { useReducer } from 'react';
import PropTypes from 'prop-types';
import AppContext from 'context/Context';
import { settings, userInfo } from './config';
import { getColor, getItemFromStore } from 'helpers/utils';
import { configReducer } from './reducers/configReducer';
import useToggleStyle from './hooks/useToggleStyle';

import { Chart as ChartJS, registerables } from 'chart.js';
import { AuthProvider } from 'context/AuthContext';
ChartJS.register(...registerables);

const Main = props => {
  const configState = {
    isFluid: getItemFromStore('isFluid', settings.isFluid),
    isRTL: getItemFromStore('isRTL', settings.isRTL),
    isDark: getItemFromStore('isDark', settings.isDark),
    navbarPosition: getItemFromStore('navbarPosition', settings.navbarPosition),
    disabledNavbarPosition: [],
    isNavbarVerticalCollapsed: getItemFromStore(
      'isNavbarVerticalCollapsed',
      settings.isNavbarVerticalCollapsed
    ),
    navbarStyle: getItemFromStore('navbarStyle', settings.navbarStyle),
    currency: settings.currency,
    showBurgerMenu: settings.showBurgerMenu,
    showSettingPanel: false,
    navbarCollapsed: false
  };

  const userState = {
    userId: getItemFromStore('userId', userInfo.userId),
    userName: getItemFromStore('userName', userInfo.userName),
    userEmail: getItemFromStore('userEmail', userInfo.userEmail),
    user: getItemFromStore('user', userInfo.user),
    remember: getItemFromStore('remember', userInfo.remember),
    integrations: getItemFromStore('integrations', userInfo.integrations),
    providers: getItemFromStore('providers', userInfo.providers),
    permissions: getItemFromStore('permissions', userInfo.permissions),
    company: getItemFromStore('company', userInfo.company),
    companies: getItemFromStore('companies', userInfo.companies),
    profile: getItemFromStore('profile', userInfo.profile),
    membership: getItemFromStore('membership', userInfo.membership),
    activeIntegration: getItemFromStore('activeIntegration', userInfo.activeIntegration),
    workspace: getItemFromStore('workspace', userInfo.workspace),
  }

  const [config, configDispatch] = useReducer(configReducer, configState);
  const [userData, userDispatch] = useReducer(configReducer, userState);

  const { isLoaded } = useToggleStyle(
    config.isRTL,
    config.isDark,
    configDispatch,
    userDispatch
  );

  const setConfig = (key, value) => {
    configDispatch({
      type: 'SET_CONFIG',
      payload: {
        key,
        value,
        setInStore: [
          'isFluid',
          'isRTL',
          'isDark',
          'navbarPosition',
          'isNavbarVerticalCollapsed',
          'navbarStyle'
        ].includes(key)
      }
    });
  };

  const setUserData = (key, value) => {
    userDispatch({
      type: 'SET_CONFIG',
      payload: {
        key,
        value,
        setInStore: [
          'userId',
          'userName',
          'userEmail',
          'user',
          'remember',
          'integrations',
          'providers',
          'permissions',
          'company',
          'companies',
          'profile',
          'membership',
          'activeIntegration',
          'workspace',
        ].includes(key)
      }
    });
  }

  if (!isLoaded) {
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          backgroundColor: config.isDark ? getColor('dark') : getColor('light')
        }}
      />
    );
  }

  return (
    <AppContext.Provider value={{ config, setConfig, configDispatch, userData, setUserData, userDispatch }}>
      <AuthProvider>
        {props.children}
      </AuthProvider>
    </AppContext.Provider>
  );
};

Main.propTypes = { children: PropTypes.node };

export default Main;
